import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import TitleBar from "components/TitleBar";

const BankWiseExposureByValue = ({ data, isLoading, isError }) => {

    const colorPlate = ["#D81B60", "#FF9800", "#9C27B0"];
    const statusConfig = [
        {
            key: "abgAmount",
            color: colorPlate[0],
            label: "ABG"
        },
        {
            key: "pbgAmount",
            color: colorPlate[1],
            label: "PBG"
        },
        {
            key: "rbgAmount",
            color: colorPlate[2],
            label: "RBG"
        },
    ];


    const maxValue = Math.max(
        ...data.map(
            item =>
                (item.abgAmount || 0) +
                (item.pbgAmount || 0) +
                (item.rbgAmount || 0)
        )
    );

    let divisor = 1;
    let unit = "";

    if (maxValue >= 100000) {
        divisor = 100000;

    }
    else if (maxValue >= 10000) {
        divisor = 10;
    }



    const categories = data.map((item) => item.bankName);

    const series = statusConfig.map((status) => ({
        name: status.label,
        color: status.color,

        data: data.map((item) => ({
            y: Number((item[status.key] || 0).toFixed(2)),
            bankName: item.bankName,
            guaranteeType: status.key,
        })),
    }));
    const options = {
        chart: {
            type: "column",
            height: 400,
        },

        title: {
            text: "",
        },

        xAxis: {
            categories,
        },

        yAxis: {
            min: 0,

            title: {
                text: 'Amount (Lakhs)',
            },

            labels: {
                formatter: function () {
                    return Highcharts.numberFormat(
                        this.value / divisor,
                        0
                    );
                },
            },

            stackLabels: {
                enabled: true,
                formatter: function () {
                    return Highcharts.numberFormat(this.total, 2);
                },
                style: {
                    fontSize: "10px",
                    fontWeight: "500",
                    color: "#374151",
                },
            },
        },
        tooltip: {
            headerFormat: "<b>{point.category}</b><br/>",
            pointFormatter: function () {
                return `
            ${this.series.name}: ₹${Highcharts.numberFormat(this.y, 2)}
            <br/>Total: ₹${Highcharts.numberFormat(this.total, 2)}
        `;
            },
        },

        plotOptions: {
            column: {
                stacking: "normal",
                borderRadius: 4,
                borderWidth: 0,
                dataLabels: {
                    enabled: false,
                },
                // point: {
                //     events: {
                //         click: function () {

                //             const category = this.category;
                //             const status = this.series.name;
                //             console.log({
                //                 category,
                //                 status,
                //                 value,
                //             });
                //             handleCategoryClick({
                //                 category,
                //                 status,
                //                 value,
                //             });
                //         },
                //     },
                // },
            },
        },

        series,

        credits: {
            enabled: false,
        },
    };

    return (
        <Box>
            <TitleBar
                title={"Bank Wise Exposure"}
                description={"Bank-wise distribution of active bank guarantees based on value"}
            />

            <Grid
                container
                spacing={2}
                sx={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 2,
                }}
            >

                {/* Right Side Chart */}
                <Grid size={12}>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default BankWiseExposureByValue;